import React from "react";
import { Helmet } from "react-helmet";
import Layout from "./Layout";

function Faqs() {
  return (
    <Layout customClass="content-area">
      <Helmet>
        <title>FAQs - Instant QR Codes</title>
        <met
          name="description"
          content="Frequently Asked Questions related to InstantQRCodes, Learn all faq regarding qr codes and qr code generator."
        />
        <link rel="canonical" href="https://instantqrcodes.com/faqs/" />
        {`
        <script type="application/ld+json">
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "What is a QR Code?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "A QR code is a type of matrix barcode invented in 1994 by the Japanese automotive company Denso Wave. A barcode is a machine-readable optical label that can contain information about the item to which it is attached. In simple word, it is an image that can store some kind of data that can be retrieved when scanned with a QR Scanner (for eg: Smartphone Camera)"
                }
              },{
                "@type": "Question",
                "name": "Why should i use a QR Code?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "A QR Code can store variety of data, so it's a faster & simpler way to share data with many people. As everyone out there have a smartphone these days, the potential is so high."
                }
              },{
                "@type": "Question",
                "name": "Does it have any expiration?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "No. Once you generate a QR Code, you can use it for lifetime."
                }
              },{
                "@type": "Question",
                "name": "How much time it takes to create a one?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "You can create a QR Code almost instantly with our tool, try it today, you will love it!"
                }
              },{
                "@type": "Question",
                "name": "What size will be the generated QR?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Right now, we are giving a 1000 x 1000 sized QR Code. We believe this is an ideal size, and can be used for both online & printing uses. We do have plan to provide different sizes in the next phase, stay tuned!"
                }
              },{
                "@type": "Question",
                "name": "What type of QR code you support?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "We currently support following types of QR Code generation: URL, Texts, Phone, vCard, WhatsApp, SMS, and UPI."
                }
              },{
                "@type": "Question",
                "name": "Can i track who scanned my QR Code?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Unfortunately Not at this time. But we do have this in pipeline."
                }
              }]
            }
        </script>
        `}
      </Helmet>
      <h3>FAQs</h3>
      <p>
        We have designed this tool as simple as possible, so we believe using
        this tool will be as simple as 1-2-3. Yet, we will be discussing here
        frequently asked questions for those who still need a push.
      </p>
      <ul itemscope itemtype="https://schema.org/FAQPage">
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">What is a QR Code?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              A QR code is a type of matrix barcode invented in 1994 by the
              Japanese automotive company Denso Wave. A barcode is a
              machine-readable optical label that can contain information about
              the item to which it is attached. In simple word, it is an image
              that can store some kind of data that can be retrieved when
              scanned with a QR Scanner (for eg: Smartphone Camera)
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">Why should i use a QR Code?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              A QR Code can store variety of data, so it's a faster &amp;
              simpler way to share data with many people. As everyone out there
              have a smartphone these days, the potential is so high.
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">Does it have any expiration?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              No. Once you generate a QR Code, you can use it for lifetime.
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">How much time it takes to create a one?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              You can create a QR Code almost instantly with our tool, try it
              today, you will love it!
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">What size will be the generated QR?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              Right now, we are giving a 1000 x 1000 sized QR Code. We believe
              this is an ideal size, and can be used for both online &amp;
              printing uses. We do have plan to provide different sizes in the
              next phase, stay tuned!
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">What type of QR code you support?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              We currently support following types of QR Code generation:
              <br />
              - URL (website)
              <br />
              - Texts (Any texts)
              <br />
              - Phone (Scan to Call)
              <br />
              - vCard (Share contact cards ultra-fast!)
              <br />
              - WhatsApp (Scan to WhatsApp)
              <br />
              - SMS (Faster SMS)
              <br />- UPI (Recieve money instantly)
            </p>
          </div>
        </li>
        <li
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <h5 itemprop="name">Can i track who scanned my QR Code?</h5>
          <div
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <p itemprop="text">
              Unfortunately Not at this time. But we do have this in pipeline.
            </p>
          </div>
        </li>
      </ul>
    </Layout>
  );
}

export default Faqs;
